import { TBrokerConfig } from '../../../types/newbuildingBroker';
import { useApplicationContext } from '../../../utils/applicationContext';

export const useBrokerConfig = (): TBrokerConfig => {
  const { config } = useApplicationContext();

  const brokerConfig: TBrokerConfig | null = config.get('newbuildingBroker');

  return {
    enabled: brokerConfig?.enabled || false,
  };
};
